export default __webpack_public_path__ + "static/IBMPlexSans-MediumItalic-Latin1-ffb5e7febb985920b9615f6a9d7830b4.woff";